import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { isAndroid, isIOS } from 'react-device-detect';
const SMSSendingToLead: React.FunctionComponent = () => {
  const [searchParams] = useSearchParams();
  const pcampaignid = searchParams.get('pcampaignid');
  useEffect(() => {
    redirectToStore();
  }, []);
  const redirectToStore = () => {
    if (isAndroid) {
      // android navigation Code
      window.location.href =
        'https://play.google.com/store/apps/details?id=app.iagri&pcampaignid=' +
        pcampaignid;
      return;
    } else if (isIOS) {
      //ios navigation Code
      window.location.href =
        'https://apps.apple.com/in/app/kshema/id6447517167?pcampaignid=' +
        pcampaignid;
      return;
    }
    // kshema.co navigation code
    return (window.location.href = 'https://kshema.co');
  };
  return <></>;
};

export default SMSSendingToLead;
